import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';
import { useFunctionShare } from './useFunctionShare';

const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayOf = (d) => { const t = new Date(`${String(d || '').slice(0, 10)}T00:00:00`); return Number.isNaN(t.getTime()) ? '' : DAY[t.getDay()]; };

// Desktop "share these functions": tick the ceremonies on the left (compact
// bordered rows, date + time on the right), read the message exactly as it
// will arrive on the right. Footer tells how many are ticked.
export default function ShareFunctionsDesktop(props) {
  const vm = useFunctionShare(props);
  const {
    invitable, picked, toggle, allOn, toggleAll, chosen,
    from, setFrom, message, setMessage, withMap, setWithMap,
    preview, copy, whatsapp, share, canShare, close,
  } = vm;

  return (
    <Modal
      dense className="ev-share-modal" title="Share functions" onClose={close}
      footer={<>
        <span className="ev-summary">
          {chosen.length
            ? <><strong>{chosen.length}</strong> of {invitable.length} {invitable.length === 1 ? 'function' : 'functions'} in the message</>
            : 'Tick at least one function'}
        </span>
        <button className="btn light" onClick={close}>Close</button>
        {canShare && <button className="btn light" onClick={share}>↗ Share</button>}
        <button className="btn light" onClick={copy}>⧉ Copy</button>
        <button className="btn primary" data-save="primary" disabled={!chosen.length} onClick={whatsapp}>
          Send on WhatsApp
        </button>
      </>}
    >
      <div className="ev-share-layout">
        <div>
          <div className="ev-section">
            <span className="step-label">Which functions</span>
            <span className="ev-tools">
              <button type="button" className="ev-link" onClick={toggleAll}>{allOn ? 'None' : 'All'}</button>
            </span>
          </div>
          <div className="ev-share-list">
            {invitable.length === 0 && <div className="muted">Every function of this event is over.</div>}
            {invitable.map(f => {
              const on = picked.includes(String(f.FunctionId));
              return (
                <label key={f.FunctionId} className={'ev-share-fn' + (on ? ' on' : '')}
                  title={[f.FunctionName, f.Venue].filter(Boolean).join(' · ')}>
                  <input type="checkbox" checked={on} onChange={() => toggle(f.FunctionId)} />
                  <span className="ev-share-name">{f.FunctionName}{f.Venue ? <span className="muted"> · {f.Venue}</span> : null}</span>
                  <span className="ev-share-when">
                    {dayOf(f.FunctionDate)} {fmtDate(f.FunctionDate).slice(0, 5)}{f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}
                  </span>
                </label>
              );
            })}
          </div>

          <label className="field">Message on top
            <textarea rows={2} value={message} onChange={e => setMessage(e.target.value)}
              placeholder="With great joy we invite you…" />
          </label>
          <label className="field">From
            <input value={from} onChange={e => setFrom(e.target.value)} placeholder="Ailani Family" />
          </label>
          <label className="share-fn-map">
            <input type="checkbox" checked={withMap} onChange={e => setWithMap(e.target.checked)} />
            Add a map link for each venue
          </label>
        </div>

        <div>
          <div className="ev-section"><span className="step-label">What they receive</span></div>
          <div className="share-fn-preview">
            {preview.map(line => (
              <div key={line.key} className={line.signature ? 'share-fn-sign' : undefined}>
                {line.parts.map((p, i) => (p.bold ? <strong key={i}>{p.text}</strong> : <span key={i}>{p.text}</span>))}
                {line.parts.length === 0 ? ' ' : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
